<template>
  <div class="main-content">
    <section class="section">
      <!-- Breadcrumb -->
      <PageHeaderNoAction>
       </PageHeaderNoAction>
      <div class="section-body">
        <DataFilter :gridId="gridId" :isExport="false" :hasNew="true" newLink="/isWorkForm/Request"></DataFilter>
        <SlickGrid :gridId="gridId" :editable="false" :frozenColumn="2" :isAutoInitData="true" baseUrl="/isWorkForm"/>
      </div>
    </section>
  </div>
</template>


<script>
import api from "@/api";
import config from "@/config";
import { mapActions, mapGetters } from "vuex";
import helper from "@/vueHelper";

export default {
  title: "isWork Form List",
  access_code: "IWF_LIST01",
  icon: "fas fa-paper-plane fa-fw",
  components: {},
  order:7,
  data() {
    return {
      gridId: "list01",
      formData: {
        staff_name: ""
      }
    };
  },
  created() {
  },
  computed: {
    ...mapGetters("grid", ["getGridById"]),

    grid() {
      return _.cloneDeep(this.getGridById(this.gridId));
    },
    dataList() {
      return this.grid.selectRows || [];
    },

  },
  mounted() {},
  methods: {
    ...mapActions("grid", ["actionResetGrid", "actionSetGrid", "actionRequest"]),

  }
};
</script>

<style scoped>
.section-body{
  padding-top:100px
}
</style>